import React from 'react'
import bg from '../../../public/static/image-background/logo-v-02.png'
import { useTranslation, getBase64 } from '../../../constants/helpers'

const Mauranking4 = ({ dataTable, dataSeason, size, id }) => {
    const { t } = useTranslation()
    const width = size
    const px = width / 100

    const color = {
        first: '#FFD700',     // Metallic Gold
        second: '#FFF0A0',    // Pale Gold
        third: '#B8860B',     // Dark Gold
        fourth: '#e0c060',    // Muted Gold
        text: '#ffffff',
        subText: 'rgba(255,240,200,0.8)',
        bg: '#0a0a0a',        // Jet Black
        rowEven: 'rgba(255,215,0,0.04)',
        rowOdd: 'rgba(10,10,10,0.95)'
    }

    return (
        <div id={id} style={{ width: width, minHeight: width / 1.3, padding: `${1.6 * px}px`, fontFamily: 'SFUHelveticaCondensedBold', backgroundColor: color.bg, position: 'relative', overflow: 'hidden' }}>

            {/* Gold radial glow */}
            <div style={{ position: 'absolute', top: '35%', left: '50%', transform: 'translate(-50%, -50%)', width: `${px * 130}px`, height: `${px * 80}px`, background: 'radial-gradient(ellipse, rgba(255,215,0,0.06) 0%, transparent 70%)', zIndex: 0 }} />
            {/* Diagonal texture */}
            <div style={{
                position: 'absolute', top: 0, left: 0, width: '100%', height: '100%', zIndex: 0,
                backgroundImage: `repeating-linear-gradient(45deg, rgba(255,215,0,0.015) 0px, rgba(255,215,0,0.015) 1px, transparent 1px, transparent 8px)`
            }} />

            <div style={{ position: 'relative', zIndex: 1, width: '100%', padding: `${px * 1.5}px`, display: 'flex', flexDirection: 'column' }}>

                {/* Header */}
                <div style={{ display: 'flex', flexDirection: 'row', justifyContent: 'space-between', alignItems: 'center', borderBottom: `1px solid rgba(255,215,0,0.35)`, paddingBottom: `${px * 1.5}px`, marginBottom: `${px * 2}px` }}>
                    <div style={{ flex: 1 }}>
                        <Image src={dataSeason?.logo} style={{ width: `${px * 8}px`, height: `${px * 8}px`, objectFit: 'contain', filter: `drop-shadow(0 0 8px rgba(255,215,0,0.8))` }} />
                    </div>
                    <div style={{ flex: 6 }}>
                        <h1 style={{ textAlign: 'center', color: color.fourth, fontSize: `${2.8 * px}px`, textTransform: 'uppercase', letterSpacing: `${px * 0.2}px`, textShadow: `0 0 10px rgba(255,215,0,0.4)`, margin: 0 }}>{dataSeason?.name}</h1>
                    </div>
                    <div style={{ flex: 1, display: 'flex', justifyContent: 'flex-end' }}>
                        <Image src={bg} style={{ width: `${px * 8}px`, height: `${px * 8}px`, objectFit: 'contain', filter: `drop-shadow(0 0 4px rgba(255,215,0,0.3))` }} />
                    </div>
                </div>

                {/* Title */}
                <div style={{ textAlign: 'center', marginBottom: `${px * 0.5}px` }}>
                    <h1 style={{
                        fontSize: `${5 * px}px`,
                        textTransform: 'uppercase',
                        fontWeight: 'bold',
                        letterSpacing: `${px * 0.3}px`,
                        margin: 0,
                        lineHeight: 1.1,
                        background: `linear-gradient(180deg, #FFF0A0 0%, #FFD700 50%, #B8860B 100%)`,
                        WebkitBackgroundClip: 'text',
                        WebkitTextFillColor: 'transparent',
                        backgroundClip: 'text',
                        filter: `drop-shadow(0 0 6px rgba(255,215,0,0.4))`
                    }}>
                        {t('rankings')}
                    </h1>
                </div>

                {/* Gold divider */}
                <div style={{ width: '60%', margin: `0 auto ${px * 2.5}px`, height: `${px * 0.2}px`, background: `linear-gradient(90deg, transparent, ${color.first}, transparent)` }} />

                {/* Tables */}
                {dataTable.map((group, groupIdx) => (
                    <div key={`${groupIdx}${group?.id}`} style={{ width: '100%', marginBottom: `${px * 3}px` }}>

                        {/* Group name (cup mode) */}
                        {dataSeason?.settings?.type?.type === 'cup' && (
                            <h3 style={{
                                textTransform: 'uppercase',
                                fontSize: `${3 * px}px`,
                                textAlign: 'center',
                                marginBottom: `${px}px`,
                                background: `linear-gradient(180deg, #FFF0A0, #FFD700)`,
                                WebkitBackgroundClip: 'text',
                                WebkitTextFillColor: 'transparent',
                                backgroundClip: 'text'
                            }}>
                                {t('group')} {group?.name}
                            </h3>
                        )}

                        {/* Table */}
                        <div style={{ width: '100%', border: `1px solid rgba(255,215,0,0.4)`, borderRadius: `${px * 1.5}px`, overflow: 'hidden', boxShadow: `0 0 20px rgba(255,215,0,0.1), inset 0 0 15px rgba(255,215,0,0.03)` }}>
                            <table width="100%" style={{ borderCollapse: 'collapse' }}>
                                <thead>
                                    <tr style={{ background: `linear-gradient(90deg, rgba(184,134,11,0.6) 0%, rgba(255,215,0,0.25) 50%, rgba(184,134,11,0.6) 100%)` }}>
                                        <td style={{ color: color.first, fontSize: `${1.8 * px}px`, fontFamily: 'SFUHelveticaCondensedBold', paddingLeft: `${px * 1.5}px`, width: '5%', padding: `${px * 1}px ${px * 0.5}px`, textShadow: `0 0 6px rgba(255,215,0,0.5)` }}>#</td>
                                        <td style={{ color: color.text, fontSize: `${1.8 * px}px`, fontFamily: 'SFUHelveticaCondensedBold', width: '28%', textTransform: 'uppercase', padding: `${px * 1}px ${px * 0.5}px` }}>{t('team')}</td>
                                        <td style={{ color: color.fourth, fontSize: `${1.8 * px}px`, fontFamily: 'SFUHelveticaCondensedBold', textAlign: 'center', width: '7%', padding: `${px * 1}px ${px * 0.5}px` }}>{t('games_played_app')}</td>
                                        <td style={{ color: color.fourth, fontSize: `${1.8 * px}px`, fontFamily: 'SFUHelveticaCondensedBold', textAlign: 'center', width: '7%', padding: `${px * 1}px ${px * 0.5}px` }}>{t('wins_app')}</td>
                                        <td style={{ color: color.fourth, fontSize: `${1.8 * px}px`, fontFamily: 'SFUHelveticaCondensedBold', textAlign: 'center', width: '7%', padding: `${px * 1}px ${px * 0.5}px` }}>{t('draw_app')}</td>
                                        <td style={{ color: color.fourth, fontSize: `${1.8 * px}px`, fontFamily: 'SFUHelveticaCondensedBold', textAlign: 'center', width: '7%', padding: `${px * 1}px ${px * 0.5}px` }}>{t('lose_app')}</td>
                                        <td style={{ color: color.fourth, fontSize: `${1.8 * px}px`, fontFamily: 'SFUHelveticaCondensedBold', textAlign: 'center', width: '7%', padding: `${px * 1}px ${px * 0.5}px` }}>{t('goals_for_app')}</td>
                                        <td style={{ color: color.fourth, fontSize: `${1.8 * px}px`, fontFamily: 'SFUHelveticaCondensedBold', textAlign: 'center', width: '7%', padding: `${px * 1}px ${px * 0.5}px` }}>{t('goals_against_app')}</td>
                                        <td style={{ color: color.fourth, fontSize: `${1.8 * px}px`, fontFamily: 'SFUHelveticaCondensedBold', textAlign: 'center', width: '7%', padding: `${px * 1}px ${px * 0.5}px` }}>{t('goal_difference_app')}</td>
                                        <td style={{ color: color.first, fontSize: `${2 * px}px`, fontFamily: 'SFUHelveticaCondensedBold', textAlign: 'center', width: '8%', padding: `${px * 1}px ${px * 0.5}px`, textShadow: `0 0 8px rgba(255,215,0,0.6)` }}>{t('points_app')}</td>
                                    </tr>
                                </thead>
                                <tbody>
                                    {[...group?.teams].map((team, teamIdx) => (
                                        <tr
                                            key={`${team?.recordId}-${new Date().getTime()}`}
                                            style={{
                                                background: teamIdx % 2 === 0 ? color.rowOdd : color.rowEven,
                                                borderBottom: `1px solid rgba(255,215,0,0.1)`
                                            }}
                                        >
                                            {/* Rank */}
                                            <td style={{ color: color.first, fontSize: `${2 * px}px`, fontFamily: 'SFUHelveticaCondensedBold', width: '5%', padding: `${px * 0.9}px ${px * 0.5}px`, textAlign: 'center', fontWeight: 'bold' }}>{teamIdx + 1}</td>
                                            {/* Team name */}
                                            <td style={{ color: color.text, fontSize: `${1.9 * px}px`, fontFamily: 'SFUHelveticaCondensedBold', textTransform: 'uppercase', width: '28%', padding: `${px * 0.9}px ${px * 0.5}px`, fontWeight: 'bold' }}>{team?.name}</td>
                                            {/* GP */}
                                            <td style={{ color: color.subText, fontSize: `${1.9 * px}px`, fontFamily: 'SFUHelveticaCondensedBold', textAlign: 'center', width: '7%', padding: `${px * 0.9}px ${px * 0.5}px` }}>{team?.totalMatches || 0}</td>
                                            {/* W */}
                                            <td style={{ color: color.subText, fontSize: `${1.9 * px}px`, fontFamily: 'SFUHelveticaCondensedBold', textAlign: 'center', width: '7%', padding: `${px * 0.9}px ${px * 0.5}px` }}>{team?.totalWinMatches || 0}</td>
                                            {/* D */}
                                            <td style={{ color: color.subText, fontSize: `${1.9 * px}px`, fontFamily: 'SFUHelveticaCondensedBold', textAlign: 'center', width: '7%', padding: `${px * 0.9}px ${px * 0.5}px` }}>{team?.totalDrawMatches || 0}</td>
                                            {/* L */}
                                            <td style={{ color: color.subText, fontSize: `${1.9 * px}px`, fontFamily: 'SFUHelveticaCondensedBold', textAlign: 'center', width: '7%', padding: `${px * 0.9}px ${px * 0.5}px` }}>{team?.totalLoseMatches || 0}</td>
                                            {/* GF */}
                                            <td style={{ color: color.subText, fontSize: `${1.9 * px}px`, fontFamily: 'SFUHelveticaCondensedBold', textAlign: 'center', width: '7%', padding: `${px * 0.9}px ${px * 0.5}px` }}>{team?.totalGoals || 0}</td>
                                            {/* GA */}
                                            <td style={{ color: color.subText, fontSize: `${1.9 * px}px`, fontFamily: 'SFUHelveticaCondensedBold', textAlign: 'center', width: '7%', padding: `${px * 0.9}px ${px * 0.5}px` }}>{team?.totalLoseGoals || 0}</td>
                                            {/* GD */}
                                            <td style={{ color: color.subText, fontSize: `${1.9 * px}px`, fontFamily: 'SFUHelveticaCondensedBold', textAlign: 'center', width: '7%', padding: `${px * 0.9}px ${px * 0.5}px` }}>{team?.totalDifferences || 0}</td>
                                            {/* PTS - gold highlight */}
                                            <td style={{ color: color.first, fontSize: `${2.2 * px}px`, fontFamily: 'SFUHelveticaCondensedBold', textAlign: 'center', width: '8%', padding: `${px * 0.9}px ${px * 0.5}px`, fontWeight: 'bold', textShadow: `0 0 8px rgba(255,215,0,0.5)` }}>{team?.totalScores || 0}</td>
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                        </div>
                    </div>
                ))}

                {/* Footer */}
                <p style={{ textAlign: 'right', color: `rgba(224,192,96,0.5)`, fontSize: `${2 * px}px`, fontWeight: 'bold', margin: `${px}px 0 0 0` }}>
                    {window.sessionStorage.getItem('HomeUrl') || 'VSPORTS EXCLUSIVE'}
                </p>
            </div>
        </div>
    )
}

const Image = props => {
    const [data, setData] = React.useState(null)
    React.useEffect(() => {
        if (props.src) {
            getBase64(props.src).then(r => setData(r))
        }
    }, [props.src])
    return <img {...props} src={data} alt="" />
}

const areEqual = (p, n) => {
    return JSON.stringify(p.dataSeason) === JSON.stringify(n.dataSeason) &&
        JSON.stringify(p.dataTable) === JSON.stringify(n.dataTable)
}

export default React.memo(Mauranking4, areEqual)
